<template>
    <div class="p-4">
        <admin-page-header title="답변 보존 캠페인 재배정" description="업체의 캠페인을 바꾸되, 새 캠페인에도 있는 문항의 답변은 삭제하지 않고 이어붙입니다. 표준 재배정(평가데이터 전체 삭제 후 재작성)과 달리 응답자가 다시 입력할 필요가 없습니다."/>

        <!-- 실행 탭은 lazy 가 아니라 탭을 오가도 고른 대상이 메모리에 남는다. 이력 탭은 열 때마다 새로 읽는다 -->
        <b-tabs :value="tabIndex" content-class="mt-3" @input="onTabInput">
            <b-tab title="재배정 실행">
                <remap-execute-tab @go-history="goHistory"/>
            </b-tab>
            <b-tab title="실행 이력 / 백업" lazy>
                <remap-history-tab/>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
/**
 * 답변 보존 캠페인 재배정 관리 화면 (셸).
 *
 * 담당자가 수동 SQL 로 처리하던 작업을 관리자 화면으로 옮긴 것. 파괴적 작업이라
 * 실행은 미리보기 → 확인 → 실행 2단계이며, 삭제된 원본은 이력 탭에서 회수한다.
 */
import RemapExecuteTab from './RemapExecuteTab.vue';
import RemapHistoryTab from './RemapHistoryTab.vue';

// ?tab= 값 (실행 탭은 키 생략). 탭 순서와 같다
const TAB_KEYS = ['execute', 'history'];
const tabOf = query => (query.tab === 'history' ? 'history' : 'execute');
// 탭마다 자기 키만 URL 에 둔다 — 실행 탭의 company_id(대상 업체)와 이력 탭의 company_id(필터)가 이름은 같고 뜻이 다르다
const ownQuery = query => {
    const rest = {...query};
    delete rest.tab;
    delete rest.log_id;
    return rest;
};

export default {
    name: 'CampaignRemap',
    components: {RemapExecuteTab, RemapHistoryTab},
    data() {
        return {
            // 떠난 탭의 query. 그 탭으로 돌아갈 때 다시 쓴다
            savedQuery: {execute: {}, history: {}},
        };
    },
    computed: {
        tabIndex() {
            return TAB_KEYS.indexOf(tabOf(this.$route.query));
        },
    },
    watch: {
        // 탭 버튼·뒤로가기 어느 쪽으로 떠나든 떠난 탭의 query 를 기억한다 (push 는 하지 않는다)
        '$route'(to, from) {
            const left = tabOf(from.query);
            if (left !== tabOf(to.query)) this.savedQuery[left] = ownQuery(from.query);
            this.normalizeTab();
        },
    },
    created() {
        this.normalizeTab();
    },
    methods: {
        // ?tab=execute·?tab= 처럼 기본 탭으로 읽히는 값은 URL 에서 지운다 (replace)
        normalizeTab() {
            const {query} = this.$route;
            if (!('tab' in query) || tabOf(query) === 'history') return;
            const next = {...query};
            delete next.tab;
            this.$router.replace({query: next}).catch(() => {});
        },
        // b-tabs 는 :value 가 바뀔 때도 input 을 낸다 — 이미 그 탭이면 아무것도 하지 않는다
        onTabInput(index) {
            const next = TAB_KEYS[index];
            if (!next || index === this.tabIndex) return;
            const saved = this.savedQuery[next];
            this.$router.push({query: next === 'execute' ? {...saved} : {...saved, tab: next}}).catch(() => {});
        },
        /** 실행 직후 "백업 확인": 이력 탭으로 넘어가 그 건의 상세를 연다. 이력 탭은 URL 의 log_id 로 연다 (목록 50건 밖이어도 열림). */
        goHistory(logId) {
            this.$router.push({query: {tab: 'history', log_id: String(logId)}}).catch(() => {});
        },
    },
};
</script>
